import React, { useState, useEffect } from "react";
import moment from "moment";
import { Select, Spin } from "antd";
import useHttp from "../../../hooks/use-http";
import DynamicBarChart from "../../barChart";
import DynamicColumnChart from "../../columnChart";
import DynamicLineChart from "../../lineChart";
import DynamicPieChart from "../../pieChart";

const { Option } = Select;

const CropWise = ({
  chartTitle = "Crop Wise Area Per State",
  isMaximized,
  openMaximize,
  xField = "state",
  yField = "totalArea",
  xAxisTitle = "State",
  yAxisTitle = "Area Covered (Ha)"
}) => {
  const [chartType, setChartType] = useState("pie");
  const [chartData, setChartData] = useState([]);
  const [stateTotals, setStateTotals] = useState([]);
  const [loading, setLoading] = useState(true);

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    const url = `/api/cropwisePerRegion/?orgId=${
      localStorage.getItem("orgId")
    }&userId=${localStorage.getItem("id")}&tdate=${moment().format(
      "DD/MM/YYYY"
    )}`;

    getData({ url }, (res) => {
      if (!res.states) return;

      const totals = res.states.map((st) => {
        const totalArea = st.crops?.reduce(
          (sum, crop) => sum + (crop.totalArea || 0),
          0
        );
        return {
          state: st.state,
          totalArea: totalArea.toFixed(2),
        };
      });

      setStateTotals(totals);

      const flattened = [];
      res.states.forEach((st) => {
        st.crops?.forEach((crop) => {
          flattened.push({
            state: st.state,
            cropName: crop.cropName,
            totalArea: crop.totalArea,
          });
        });
      });

      setChartData(flattened);
      setLoading(false);
    });
  }, [getData]);

  const handleChartChange = (value) => setChartType(value);

  if (isMaximized) {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <div className="flex justify-end mb-2">
          <Select value={chartType} style={{ width: 120 }} onChange={handleChartChange}>
            <Option value="pie">Pie</Option>
            <Option value="column">Column</Option>
            <Option value="bar">Bar</Option>
            <Option value="line">Line</Option>
          </Select>
        </div>

        {chartType === "pie" && (
          <DynamicPieChart
            data={chartData}
            angleField={yField}
            colorField="cropName"
            isMaximized={true}
          />
        )}

        {chartType === "column" && (
          <DynamicColumnChart
            data={chartData}
            xField={xField}
            yField={yField}
            seriesField="cropName"
            xAxisTitle={xAxisTitle}
            yAxisTitle={yAxisTitle}
          />
        )}

        {chartType === "bar" && (
          <DynamicBarChart
            data={chartData}
            xField={xField}
            yField={yField}
            seriesField="cropName"
            xAxisTitle={xAxisTitle}
            yAxisTitle={yAxisTitle}
          />
        )}

        {chartType === "line" && (
          <DynamicLineChart
            data={chartData}
            xField={xField}
            yField={yField}
            seriesField="cropName"
            xAxisTitle={xAxisTitle}
            yAxisTitle={yAxisTitle}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl shadow-md"
      style={{
        background: "#f3e8d3",
        height: "200px",
        width: "100%",
        padding: "12px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {loading ? (
        <div className="flex justify-center">
          <Spin />
        </div>
      ) : (
        <>
          <div
            style={{
              height: "170px",
              overflowY: "auto",
              paddingRight: "6px",
            }}
          >
            {stateTotals.map((st, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "5px 6px",
                  borderBottom: "1px solid #e2e2e2",
                  fontSize: "15px",
                  color: "#3d5c26",
                  fontWeight: "600",
                }}
              >
                <span>{st.state}</span>
                <span>{st.totalArea} Ha</span>
              </div>
            ))}
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "6px",
              right: "12px",
              cursor: "pointer",
              fontWeight: "600",
              color: "#3d5c26",
              fontSize: "14px",
            }}
            onClick={openMaximize}
          >
            More...
          </div>
        </>
      )}
    </div>
  );
};

export default CropWise;
